// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`Details component should render without throwing an error 1`] = `
<div
  className="details"
>
  First Detail | Second Detail
</div>
`;
